var map = {
	"./icons-10/stars_empty.svg": 14080,
	"./icons-10/stars_full.svg": 54042,
	"./icons-120/empty_state_payments.svg": 12976,
	"./icons-120/empty_state_taxes.svg": 36484,
	"./icons-120/entry_state_scheduled_payments.svg": 86001,
	"./icons-120/secure_payments.svg": 47964,
	"./icons-16/download.svg": 77761,
	"./icons-16/error.svg": 68661,
	"./icons-16/failed.svg": 51102,
	"./icons-16/settings-outline.svg": 72375,
	"./icons-16/success.svg": 28390,
	"./icons-16/v-shield.svg": 76821,
	"./icons-16/warning.svg": 3819,
	"./icons-16/xperts.svg": 20955,
	"./icons-16/zoom-plus.svg": 15345,
	"./icons-24/add-client.svg": 14251,
	"./icons-24/apple.svg": 38472,
	"./icons-24/appointment.svg": 68383,
	"./icons-24/credit-card.svg": 57578,
	"./icons-24/document.svg": 70523,
	"./icons-24/estimate.svg": 56954,
	"./icons-24/event.svg": 87376,
	"./icons-24/exclamation-circle.svg": 56480,
	"./icons-24/exclamation-triangle.svg": 64248,
	"./icons-24/google.svg": 38885,
	"./icons-24/instagram.svg": 9036,
	"./icons-24/internal_document.svg": 12141,
	"./icons-24/invite-to-portal.svg": 49026,
	"./icons-24/invite-to-schedule.svg": 20647,
	"./icons-24/invite-via-email.svg": 70595,
	"./icons-24/invoice.svg": 96441,
	"./icons-24/message.svg": 13965,
	"./icons-24/messager.svg": 85573,
	"./icons-24/new-message.svg": 44264,
	"./icons-24/new-note.svg": 55427,
	"./icons-24/package.svg": 22040,
	"./icons-24/payments.svg": 8429,
	"./icons-24/point_of_sale.svg": 8768,
	"./icons-24/product.svg": 66629,
	"./icons-24/recurring-appointment.svg": 43201,
	"./icons-24/recurring-event.svg": 96774,
	"./icons-24/register-to-event.svg": 65576,
	"./icons-24/request-payment.svg": 32702,
	"./icons-24/request_signature.svg": 64152,
	"./icons-24/review.svg": 1292,
	"./icons-24/scheduled-payments.svg": 84563,
	"./icons-24/send-promotion.svg": 40122,
	"./icons-24/web-chat.svg": 75605,
	"./icons-24/whatsapp.svg": 63738,
	"./icons-28/canceled-appointment.svg": 85009,
	"./icons-28/expired.svg": 22063,
	"./icons-28/hand-cash.svg": 54017,
	"./icons-28/last-appointment.svg": 96496,
	"./icons-28/noshow.svg": 43138,
	"./icons-28/package.svg": 63724,
	"./icons-28/pending-payments.svg": 83535,
	"./icons-28/total-payments.svg": 70542,
	"./icons-28/upcoming-appointment.svg": 94258,
	"./icons-28/zoom.svg": 82581,
	"./icons-misc/Add_to_website.svg": 88091,
	"./icons-misc/App_client_portal.svg": 60252,
	"./icons-misc/Direct_Links.svg": 93939,
	"./icons-misc/Document.svg": 32409,
	"./icons-misc/Invite_clients.svg": 27052,
	"./icons-misc/amex.svg": 41639,
	"./icons-misc/amexa.svg": 15940,
	"./icons-misc/campaign.svg": 13644,
	"./icons-misc/diners.svg": 1505,
	"./icons-misc/discover.svg": 91987,
	"./icons-misc/discovera.svg": 4488,
	"./icons-misc/empty_autobilling_method.svg": 48530,
	"./icons-misc/invoice_draft.svg": 89199,
	"./icons-misc/jcb.svg": 58559,
	"./icons-misc/maestro.svg": 87289,
	"./icons-misc/mastercard.svg": 74686,
	"./icons-misc/mastercarda.svg": 29939,
	"./icons-misc/multi-users.svg": 56506,
	"./icons-misc/new_invoice.svg": 43512,
	"./icons-misc/play.svg": 2187,
	"./icons-misc/record_payment.svg": 40086,
	"./icons-misc/unionpay.svg": 5259,
	"./icons-misc/upload.svg": 82777,
	"./icons-misc/user.svg": 87827,
	"./icons-misc/visa.svg": 15289,
	"./icons-misc/visaa.svg": 81578
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22433;